import { twClassMerge } from '@healthhub/react-ui';
import { Button, Spin, Typography } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FilledDownloadPdfIcon } from '@shared/assets-icon';
import { useLayoutViewContext } from '@shared/context';

import { DownloadingFileModal } from '../Modals/DownloadingFileModal';

const { Text } = Typography;

interface DownloadPDFButtonProps {
  customText?: string;
  handleDownloadPDF?: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  textClassName?: string;
}

const DownloadPDFButton = ({
  customText,
  handleDownloadPDF,
  isDisabled,
  isLoading,
  textClassName,
}: DownloadPDFButtonProps) => {
  const { isMobileView, isSharedServiceView } = useLayoutViewContext();

  const { t } = useTranslation();
  const hasLoadingRef = useRef<boolean | undefined>(false);
  const [isOpenDownloadingModal, setIsOpenDownloadingModal] = useState(false);

  useEffect(() => {
    if ((isMobileView || isSharedServiceView) && isLoading) {
      setIsOpenDownloadingModal(true);
    }

    if (hasLoadingRef.current && !isLoading) {
      setIsOpenDownloadingModal(false);
    }

    hasLoadingRef.current = isLoading;
  }, [isLoading, isMobileView, isSharedServiceView]);

  return (
    <>
      <Button
        className="flex w-fit flex-row gap-1 pl-0 font-semibold h-auto"
        disabled={isDisabled}
        onClick={handleDownloadPDF}
        type="text"
      >
        <FilledDownloadPdfIcon className="size-5.5 shrink-0" />
        <Text
          className={twClassMerge(
            'font-semibold text-wrap text-left text-base',
            {
              'text-gray-600': isDisabled,
              'text-primary-blue': !isDisabled,
            },
            textClassName
          )}
        >
          {customText ?? t('pdf.downloadPdf')}
        </Text>
        {!!isLoading && !isMobileView && !isSharedServiceView && <Spin className="ml-2" />}
      </Button>
      <DownloadingFileModal open={isOpenDownloadingModal} />
    </>
  );
};

export default DownloadPDFButton;
